type AccessGuideReasonCopy = {
  [key: string]: string
}

type ModalCopyLocale = {
  accessGuideTitle: string
  accessGuideOkPay: string
  accessGuideOkKnow: string
  accessGuideCancel: string
  accessGuideExpirePrefix: string
  accessGuidePhonePrefix: string
  defaultSalesPhone: string
  paymentTitle: string
  paymentSuccessTitle: string
  paymentSuccessSubtitle: string
  paymentErrorTitle: string
  paymentErrorSubtitle: string
  paymentCreatingOrder: string
  paymentChannelBadge: string
  paymentAmountLabel: string
  paymentScanHint: string
  paymentAutoRefreshHint: string
  paymentOrderPrefix: string
  paymentCreateOrderFailed: string
  accessGuideReasonCopy: AccessGuideReasonCopy
}

export const modalCopyLocales: Record<string, ModalCopyLocale> = {
  'zh-CN': {
    accessGuideTitle: '访问受限',
    accessGuideOkPay: '立即个人付费',
    accessGuideOkKnow: '我知道了',
    accessGuideCancel: '取消',
    accessGuideExpirePrefix: '最近授权截止：',
    accessGuidePhonePrefix: '联系电话：',
    defaultSalesPhone: '136 9329 0406',
    paymentTitle: '项目个人年付',
    paymentSuccessTitle: '支付成功',
    paymentSuccessSubtitle: '权限正在刷新',
    paymentErrorTitle: '支付失败或二维码已过期',
    paymentErrorSubtitle: '请关闭后重试',
    paymentCreatingOrder: '正在创建支付订单，请稍候...',
    paymentChannelBadge: '微信官方通道 安全支付',
    paymentAmountLabel: '个人年付金额',
    paymentScanHint: '请使用微信扫码完成支付',
    paymentAutoRefreshHint: '支付完成后将自动刷新权限，约 1-3 秒生效',
    paymentOrderPrefix: '订单号：',
    paymentCreateOrderFailed: '创建支付订单失败',
    accessGuideReasonCopy: {
      personal_user: '你尚未加入机构，可先加入机构使用授权，或个人付费继续使用。',
      college_course_unconfigured: '机构尚未配置该项目，请联系机构管理员/工作人员开通，或个人付费继续使用。',
      college_or_course_expired: '机构授权已过期，可联系销售续约机构，或个人付费继续使用。',
      course_not_found: '当前项目信息不存在或已下线，请联系管理员确认，或选择其他项目。',
    },
  },
}

export const modalCopy = modalCopyLocales['zh-CN']

export const getAccessGuideContentByReason = (payReason: string, defaultContent: string) => {
  return modalCopy.accessGuideReasonCopy[payReason] || defaultContent
}
